<template>
  <div class="clientsList">
    <default-header :h2="$t('clientList.title')"></default-header>

    <div class="innerContent justifyContentFlexStart">
      <div class="clientsList__searchBox">
        <input type="text" v-model="searchText" class="clientsList__searchBox__input" />
        <span class="clientsList__searchBox__icon">
          <font-awesome-icon :icon="['fa', 'search' ]" />
        </span>
      </div>

      <div
        v-if="clientsList.length > 0"
        v-for="(client, index) in clientsList"
        :key="index"
        class="clientsList__item"
        @click="goToClientsDetails(client.id)"
      >
        <div class="clientsList__item-left">
          <font-awesome-icon
            v-if="getClientStatus(client.status) == 'batteryIsGood'"
            :class="[getClientStatus(client.status) == 'batteryIsGood' ? 'Good' : '']"
            :icon="['fa', 'thumbs-up' ]"
          />
          <font-awesome-icon
            v-if="getClientStatus(client.status) == 'Pending'"
            :class="[getClientStatus(client.status) == 'Pending' ? 'Pending' : '']"
            :icon="['fa', 'paper-plane' ]"
          />
          <font-awesome-icon
            v-if="getClientStatus(client.status) == 'Declined'"
            :class="[getClientStatus(client.status) == 'Declined' ? 'Declined' : '']"
            :icon="['fa', 'times-circle' ]"
          />

          <font-awesome-icon
            v-if="getClientStatus(client.status) == 'Accepted'"
            :class="[getClientStatus(client.status) == 'Accepted' ? 'Accepted' : '']"
            :icon="['fa', 'check-circle' ]"
          />

          <div class="clientsList__item-text">
            <div
              class="clientsList__item-text__name"
            >{{ client.first_name + ' ' + client.last_name }}</div>
            <div class="clientsList__item-text__subname">{{ client.created_at }}</div>
            <div class="clientsList__item-text__subname">
              {{getClientStatus(client.status) == 'batteryIsGood' ? $t('clientList.batteryIsGood')
              : getClientStatus(client.status) == 'Accepted' ? $t('clientList.accepted')
              : getClientStatus(client.status) == 'Pending' ? $t('clientList.pending')
              : getClientStatus(client.status) == 'Declined' ? $t('clientList.declined') : '' }}
            </div>
          </div>
        </div>
        <div class="clientsList__item-arrow">
          <font-awesome-icon :icon="['fas', 'arrow-circle-right' ]" />
        </div>
        <div class="clientsList__item-times" @click.stop="deleteClient(client)">
          <font-awesome-icon :icon="['fas', 'times' ]" />
        </div>
      </div>
      <div
        v-if="loading === false && clientsList.length === 0"
        class="d-flex justify-content-center mt-4 small"
      >No clients yet</div>
      <!-- INFINITE LOADING HANDLER -->
      <infinite-loading @infinite="infiniteHandler">
        <preloader slot="spinner"></preloader>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>
    <bottom-navigation></bottom-navigation>
    <ClientDeleteModal ref="modal" v-if="modalOpen"></ClientDeleteModal>
  </div>
</template>

<script>
import DefaultHeader from '@/partials/DefaultHeader';
import BottomNavigation from '@/partials/BottomNavigation';
import InfiniteLoading from 'vue-infinite-loading';
import ClientDeleteModal from '../components/ClientDeleteModal';
import { mapGetters, mapActions } from 'vuex';
import { HTTP } from '../http';
import Preloader from '../components/Preloader';
import BackBtn from '../components/BackBtn';
import _ from 'lodash';
export default {
  name: 'ClientsList',
  components: {
    BottomNavigation,
    DefaultHeader,
    InfiniteLoading,
    Preloader,
    BackBtn,
    ClientDeleteModal
  },
  data() {
    return {
      clientsList: [],
      searchText: '',
      pageNumber: 1,
      loading: true,
      modalOpen: true
    };
  },
  computed: {},
  watch: {
    searchText(newVal) {
      this.debounceGetListOfClients(newVal);
    }
  },
  methods: {
    debounceGetListOfClients: _.debounce(function(newVal) {
      this.pageNumber = 1;
      this.getListOfClients(newVal, this.pageNumber);
    }, 500),
    infiniteHandler($state) {
      this.getListOfClients(this.searchText, this.pageNumber, $state);
    },

    async deleteClient(client) {
      await this.$refs.modal.open();

      HTTP.delete(`/api/client/${client.id}`)
        .then(res => {
          this.clientsList = this.clientsList.filter(item => item !== client);
        })
        .catch(res => console.log);
    },

    goToClientsDetails(id) {
      localStorage.setItem('exideActiveClientID', id);
      this.$router.push({ name: 'ClientDetails' });
    },
    getListOfClients(searchText, page, $state) {
      if (page === 1) {
        this.clientsList = [];
      }
      this.loading = true;
      HTTP.get(`/api/clients?page=${page}&name=${searchText}`)
        .then(res => {
          this.loading = false;
          let fetchedClients = res.data.data;
          if (fetchedClients.length > 0) {
            if (this.clientsList.length === 0) {
              this.clientsList = fetchedClients;
            } else {
              fetchedClients.forEach(client => {
                this.clientsList.push(client);
              });
            }
            $state.loaded();
            this.pageNumber = this.pageNumber + 1;
          } else {
            if ($state) {
              $state.complete();
            }
          }
        })
        .catch(err => {
          this.loading = false;
          if ($state) {
            $state.complete();
          }
        });
    },
    getClientStatus(status) {
      if (status == null) {
        return 'batteryIsGood';
      }
      switch (status.value) {
        case 0:
          return 'Pending';
          break;

        case 1:
          return 'Accepted';
          break;

        case 2:
          return 'Declined';
          break;

        default:
          return '-';
          break;
      }
    }
  }
};
</script>

